import { useMutation } from '@tanstack/react-query'
import { AxiosError } from 'axios'
import { usePublicAxiosInstance } from './usePublicAxiosInstance'
import { CreateSessionRequestBody, Session } from './types'

export const usePublicApi = () => {
    const axiosInstance = usePublicAxiosInstance()

    const useLoginMutation = () => {
        return useMutation<Session, AxiosError, CreateSessionRequestBody>({
            mutationFn: async (credentials) => {
                const response = await axiosInstance.post<Session>(
                    '/api/v1/sessions',
                    credentials
                )
                return response.data
            },
        })
    }

    return {
        useLoginMutation,
    }
}
